/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const ConcernsIssueSummaryDto = zod.object({
  "id": zod.string().uuid().optional(),
  "dailyActivityMonitoringId": zod.string().uuid().optional(),
  "concernDate": zod.coerce.date().optional(),
  "memberId": zod.string().uuid().optional(),
  "memberName": zod.string().optional(),
  "coordinatorId": zod.string().uuid().optional(),
  "coordinatorName": zod.string().optional(),
  "concernsIssueTypeId": zod.number().optional(),
  "concernsIssueTypeName": zod.string().optional(),
  "statusId": zod.number().optional(),
  "statusName": zod.string().optional(),
  "description": zod.string().optional(),
  "createdBy": zod.string().optional(),
  "createdDate": zod.coerce.date().optional(),
  "dailyActivityMonitoringLogStatusId": zod.number().optional()
});

export type ConcernsIssueSummaryDto = zod.input<typeof ConcernsIssueSummaryDto>;
export type ConcernsIssueSummaryDtoOutput = zod.output<typeof ConcernsIssueSummaryDto>;
